import React from 'react';
import PropTypes from 'prop-types';

import Select from 'components/Select';

const mapOption = (item) => ({
  label: item.name,
  value: item.id,
});

class GroupsDropdown extends React.PureComponent {
  handleChange = ({ value }) => {
    const { items } = this.props.initialData;
    const group = items.find((i) => i.id === value);
    this.props.onChange(group);
  };

  render() {
    const { items } = this.props.initialData;
    const { value, excludeIds } = this.props;
    const selectItems = items.filter(({ id }) => !excludeIds.includes(id));
    return (
      <Select
        options={selectItems.map(mapOption)}
        placeholder="Select group"
        value={value ? mapOption(value) : null}
        onChange={this.handleChange}
      />
    );
  }
}

GroupsDropdown.propTypes = {
  initialData: PropTypes.shape({
    items: PropTypes.array,
  }).isRequired,
  value: PropTypes.object,
  excludeIds: PropTypes.array,
  onChange: PropTypes.func,
};

export default GroupsDropdown;
